import api from './api';

const getRevenue = async () => {
  const response = await api({
    method: 'GET',
    url: '/revenue',
  });

  return response;
};

export { getRevenue };
